import { useModal } from 'src/hooks/modalHooks';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
  DataTableActionsButton,
  useRowClickHandler,
} from 'src/components/DataTable';
import { SolutionAssetConfigListItem } from '../../types';
import SolutionAssetConfigViewModal from './SolutionAssetConfigViewModal';

type Props = {
  item?: SolutionAssetConfigListItem;
};

function SolutionAssetConfigAction({ item }: Props) {
  const [AssetConfigFilesViewModal, showAssetConfigFiles] = useModal(
    SolutionAssetConfigViewModal,
    { item }
  );
  useRowClickHandler(showAssetConfigFiles);

  return (
    <>
      <DataTableActionsButton
        data-testid="solution-asset-config-files-view-action"
        icon={VisibilityOutlinedIcon}
        onClick={showAssetConfigFiles}
        title="View"
      />
      {AssetConfigFilesViewModal}
    </>
  );
}

export default SolutionAssetConfigAction;
